export default "__VITE_ASSET__B03T$9VJ__"